import React, { useState } from 'react';
import BusStopMap from './BusStopMap';
import { Card, CardHeader, CardTitle } from './ui/card';
import { MapPin } from 'lucide-react';

const BusStopMapPage = () => {
  const [selectedBusStop, setSelectedBusStop] = useState(null);

  const handleBusStopSelect = (busStop) => {
    setSelectedBusStop(busStop);
  };

  return (
    <div
      className="container mx-auto px-2 sm:px-4 py-2 sm:py-4 md:py-6 max-w-6xl flex items-stretch"
      style={{ minHeight: 'calc(100vh - 80px)', paddingBottom: 'max(1rem, env(safe-area-inset-bottom))' }}
    >
      <Card className="shadow-lg w-full flex flex-col">
        <CardHeader>
          <CardTitle className="flex items-center gap-2 text-2xl">
            <MapPin className="h-6 w-6" />
            附近巴士站地圖
          </CardTitle>
        </CardHeader>
        <div className="px-4 sm:px-6 pb-6">
          <BusStopMap
            onBusStopSelect={handleBusStopSelect}
            selectedBusStop={selectedBusStop}
          />
        </div>
      </Card>
    </div>
  );
};

export default BusStopMapPage;
